import { Component, OnInit } from '@angular/core';
import { CONSTANTS } from '../../constants';
import { NotificationService } from '../../services/notification.service';
import { DataService } from '../../services/data.service';
import { DataCollectionService } from '../../services/api/data_collection.service';
import { ConfigService } from '../../services/api/config.service';
import { DateUtil } from '../../utils/date.utils'

@Component({
  selector: 'app-data-collection',
  templateUrl: './data-collection.component.html',
  styleUrls: ['./data-collection.component.scss']
})
export class DataCollectionComponent implements OnInit {

  name = 'data-collection';
  feed_token: any = '';
  configs: any = [];
  rows: any = [];
  tmp_config: any;
  modalHeader = '';
  status = '';

  constructor(private dataService: DataService, private dcService: DataCollectionService,
    private ns: NotificationService, private configService: ConfigService, private du: DateUtil) { }

  categories: any = [ 
    { index: "-1", display_name: 'Select' }
  ];
  filter_params: any = {
    selected_category: this.categories[0].index,
    selected_date: ''
  };
  admin: any;

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.DATA_COLLECTION});
    this.filter_params.selected_date = this.du.getDate(new Date(), CONSTANTS.DATE_FORMAT.YYYYMMDD)
    this.loadCategories();
    this.loadFeedToken();
  }

  ngOnDestroy() { }

  loadCategories() {
    let ip: any = {};
    this.dcService.getCategories(ip).subscribe((response: any) => {
      if (response.response_code == 1000) {
        let categories: any = [{index: 11, display_name: 'All'}];
        response.categories.forEach((item: any) => {
          categories.push({index: `${item.index}`, display_name: item.display_name});
        });
        this.categories = categories;
        this.filter_params.selected_category = this.categories[0].index;
      }
    });
  }

  loadFeedToken() {
    let ip: any = { 'keys': 'dc_token' };
    this.configService.getConfigData(ip).subscribe((response: any) => {
      if (response.response_code == 1000) {
        this.feed_token = response.cds[0]['dc_token'];
      }
    });
  }
  saveToken() {
    let ip: any = { cds: [{ key: 'dc_token', value: this.feed_token }] };
    this.configService.updateCDatas(ip).subscribe((response: any) => {
      if (response.response_code == 1000) {
        this.ns.showAlert(CONSTANTS.SUCCESS, 'Token Updated Successfully.');
      }
    });
  }

  onCategoryChanged() { }

  runDataCollection() {
    let ip: any = { dt: this.filter_params.selected_date, index: this.filter_params.selected_category };
    this.dcService.runData(ip).subscribe((response: any) => {
      if (response.response_code == 1000) {
        // let msg: any = `Result: ${response.result} \n Error: ${response.err}`;
        // alert(msg);
        // let status: any = response.status;
        // alert(status);
      }
    });
  }

  stopDataCollection() {
    let ip: any = { };
    this.dcService.stopData(ip).subscribe((response: any) => {
      if (response.response_code == 1000) {
        // let status: any = response.status;
        // alert(status);
      }
    });
  }

  checkRunStatus() {
    let ip: any = { };
    this.dcService.checkDataRunStatus(ip).subscribe((response: any) => {
      if (response.response_code == 1000) {
        // let msg: any = `Status: ${response.status} \n Result: ${response.result} \n Error: ${response.err}`;
        // alert(msg);
        let status: any = response.status;
        alert(status);
      }
    });
  }

  checkDataCollection() {
    let ip: any = { dt: this.filter_params.selected_date, index: this.filter_params.selected_category };
    this.dcService.checkDataStatus(ip).subscribe((response: any) => {
      if (response.response_code == 1000) {
        // let msg: any = `Result: ${response.result} \n Error: ${response.err}`;
        // alert(msg);
        let data: any = response.result.data;
        let cat_keys: any = Object.keys(data);
        let rows: any = [], tmp: any = {};
        for (let idx = 0; idx < cat_keys.length; idx++) {
          tmp = data[cat_keys[idx]];
          rows.push({
            category: cat_keys[idx].toUpperCase(),
            m_count: !tmp || (tmp == null) ? 'NA' : tmp['1m'],
            d_count: !tmp || (tmp == null) ? 'NA': tmp['1d']
          });
        }
        this.rows = rows;
      }
    });
  }

  splitCategory() {
    let ip: any = { dt: this.filter_params.selected_date };
    this.dcService.splitCategories(ip).subscribe((response: any) => {
      if (response.response_code == 1000) {
        // let msg: any = `Result: ${response.result} \n Error: ${response.err}`;
        // alert(msg);
        let status: any = response.result.status;
        let success: any = status.toLowerCase() == 'ok';
        this.ns.showAlert(success ? CONSTANTS.SUCCESS : CONSTANTS.ERROR, success ? 'Success': 'Failed');
      }
    });
  }

  archiveData() {
    let ip: any = { dt: this.filter_params.selected_date };
    this.dcService.archieveData(ip).subscribe((response: any) => {
      if (response.response_code == 1000) {
        // let msg: any = `Result: ${response.result} \n Error: ${response.err}`;
        // alert(msg);
      } else {
        alert(response.errors[0].data);
      }
    });
  }

  stopArchiveData() {
    let ip: any = { };
    this.dcService.stopArchieveData(ip).subscribe((response: any) => {
      if (response.response_code == 1000) {
        let msg: any = `Result: ${response.result} \n Error: ${response.err}`;
        alert(msg);
      }
    });
  }

  checkArchiveStatus() {
    let ip: any = { };
    this.dcService.archieveDataRunStatus(ip).subscribe((response: any) => {
      if (response.response_code == 1000) {
        let status: any = response.status;
        alert(status);
      }
    });
  }
}
